export default class CSSRuleSet {
    stylesheet = new CSSStyleSheet();
    constructor(styles) {
        if (!styles) {
            return;
        }
        this.replaceRules(styles);
    }
    addSelector(selector) {
        const index = this.getRuleIndex(selector);
        if (index !== -1) {
            return index;
        }
        return this.stylesheet.insertRule(`${selector} {}`, this.stylesheet.cssRules.length);
    }
    getDeclarations(index) {
        if (index === -1) {
            return false;
        }
        const rule = this.stylesheet.cssRules.item(index);
        return rule.style;
    }
    getRuleIndex(selector) {
        const stylesAry = Array.from(this.stylesheet.cssRules);
        return stylesAry.findIndex((item) => {
            return item.selectorText === selector;
        });
    }
    setProperty(selector, key, value) {
        const index = this.addSelector(selector);
        const declarations = this.getDeclarations(index);
        if (!declarations) {
            return;
        }
        declarations.setProperty(key, value.toString());
    }
    removeProperty(selector, key) {
        const index = this.getRuleIndex(selector);
        const declarations = this.getDeclarations(index);
        if (!declarations) {
            return;
        }
        declarations.removeProperty(key);
        if (declarations.length === 0) {
            this.deleteRule(index);
        }
    }
    replaceRules(styles) {
        switch (typeof styles) {
            case 'string':
                this.stylesheet.replaceSync(styles);
                break;
            case 'object':
                this.stylesheet = styles;
                break;
        }
    }
    deleteRule(selector) {
        let index;
        switch (typeof selector) {
            case 'string':
                index = this.getRuleIndex(selector);
                break;
            case 'number':
                index = selector;
                break;
        }
        if (index === -1) {
            return;
        }
        this.stylesheet.deleteRule(index);
    }
    clearRules() {
        this.replaceRules('');
    }
    getStylesheet() {
        return this.stylesheet;
    }
}
